import IDMGlobals from './../IDMGlobals';
import IDMUtils from './../IDMUtils';
//
const CookieWrap = require('js-cookie');

/**
 *
 */
export default class Cookie {

  /**
   * constructor - description
   *
   * @return {type}  description
   */
  constructor(secureDomain) {
    this.cookieEngine = CookieWrap;
    this.secureDomain = secureDomain;
  }

  /**
   * cleanKey - description
   *
   * @param  {type} key description
   * @return {type}     description
   */
  cleanKey(key) { this.cookieEngine.remove(key, { domain: this.__getRootDomain() }); }

  /**
   * getValue - description
   *
   * @param  {type} key description
   * @return {type}     description
   */
  getValue(key) { return this.cookieEngine.get(key); }

  /**
   * setDefaultValue - description
   *
   * @param  {type} key description
   * @param  {type} val description
   * @return {type}     description
   */
  setDefaultValue(key, val) {
    return this.setValue(key, val, {expires: IDMGlobals.CookiesDefaultExpirationPeriod})
  }

  /**
   * setLongLiveValue - description
   *
   * @param  {type} key description
   * @param  {type} val description
   * @return {type}     description
   */
  setLongLiveValue(key, val) {
    return this.setValue(key, val, {expires: IDMGlobals.CookiesLongLiveExpirationPeriod})
  }

  /**
   * setValue - description
   *
   * @param  {type} key  description
   * @param  {type} val  description
   * @param  {type} opts description
   * @return {type}      description
   */
  setValue(key, val, opts) {
    return this.cookieEngine.set(key, val, {
      ...opts,
      secure: IDMGlobals.CookiesSecureStorage,
      domain: this.__getRootDomain(),
      samesite: 'none'
    });
  }


  __getRootDomain() {
    if (IDMUtils.isNodeJS()) return '';
    //
    if (this.secureDomain) return this.secureDomain;
    //
    let d = window.location.host.split(':').shift().split('.');
    if (d.length <= 1) return 'localhost'; //assume localhost
    else {
      while (d.length > 2) d.shift();
      return d.join('.');
    }
  }
}
